package com.eladfinish.bible.contest.screens.search.model

import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.all_the_bible
import com.eladfinish.bible.contest.first_last_letters_in_name
import com.eladfinish.bible.contest.lefi_hamikud
import com.eladfinish.bible.contest.pasuk_lehazmana
import com.eladfinish.bible.contest.regular_search
import com.eladfinish.bible.contest.searching_date
import com.eladfinish.bible.contest.searching_number
import com.eladfinish.bible.contest.searching_root
import com.eladfinish.bible.contest.utils.addGershaim
import com.eladfinish.bible.contest.utils.toOtiot
import dev.icerock.moko.resources.StringResource

data class ResultRegex(
    val string: String,
    val regexResult: String,
    val actualRegex: Regex?,
    val firstColonIsPartOfRegex: Boolean,
)

data class ChapterDetails(
    val bookName: String,
    val chapterName: String,
    val verses: List<String>,
) {

    fun getSource(verseIndex: Int): String =
        bookName
            .plus(" ")
            .plus(chapterName.addGershaim())
            .plus(", ")
            .plus(verseIndex.plus(1).toOtiot().addGershaim())
}

data class VerseReference(
    val bookName: String,
    val chapterName: String,
    val verse: Int,
)

data class VerseReferenceNumericBook(
    val bookIndex: Int,
    val chapterIndex: Int,
    val verse: String,
) {
    val chapterOtiot: String
        get() = chapterIndex.toOtiot()
}

enum class ClickType {
    TAP, PRESS
}

enum class HorizontalDirection {
    LEFT, RIGHT
}

enum class SearchMode(val stringResource: StringResource) {
    REGULAR_SEARCH(stringResource = SharedRes.strings.regular_search),
    FIRST_LAST_LETTERS_IN_NAME(stringResource = SharedRes.strings.first_last_letters_in_name),
    VERSE_FOR_INVITATION(stringResource = SharedRes.strings.pasuk_lehazmana),
}

data class SearchPlaceData(
    val bookIndex: Int,
    val filename: String,
)

enum class SearchPlace(val stringResource: StringResource) {
    WHOLE_BIBLE(stringResource = SharedRes.strings.all_the_bible),
    BY_MIKUD(stringResource = SharedRes.strings.lefi_hamikud),
}

enum class SearchNumberOrRoot(val stringRes: StringResource) {
    NUMBER(SharedRes.strings.searching_number),
    ROOT(SharedRes.strings.searching_root),
    DATE(SharedRes.strings.searching_date),
}

data class Sign(
    val value: String,
    val display: String,
)
